(ns iris.logs.views.user
  (:require
   [re-frame.core :as re-frame]
   [iris.logs.views.post :refer [screening-badge]]
   [iris.posts.subs :as posts-subs]
   [shadow.css :refer [css]]))


(defn- format-seen [iso]
  (when iso
    (.toUTCString (js/Date. iso))))

(defn user-btns [user]
  (let [ruid      (str "=" user)
        ss        @(re-frame/subscribe [::posts-subs/screning-status ruid])
        timespan  @(re-frame/subscribe [::posts-subs/eid-logs])]
    [:div
     [:div {:class (css "btn-group" :mb-3)}
      [:button {:class "btn btn-default" :disabled true} "Logs:"]
      [:button {:class "btn btn-default" :disabled true}
       [:em "First seen: "]
       [:strong (or (format-seen (:first_seen timespan)) "—")]]
      [:button {:class "btn btn-default" :disabled true}
       [:em "Last seen: "]
       [:strong (or (format-seen (:last_seen timespan)) "—")]]]
     [:div 
        [:a {:href (str "/user/" user)
             :class "btn btn-primary"}
        [:i {:class "glyphicon glyphicon-th"}]
        "All posts"]
      [:div.screening-badge-wrap
       [screening-badge ss ruid]]]]))
